import { gql } from 'graphql-request';

import AnnotationFragment from './AnnotationFragment';

const UpdateAnnotationMutation = gql`
  mutation UpdateAnnotation(
    $story_id: ID
    $annotation_id: ID
    $date: Date
    $title: String
    $summary: String
    $target_chart_dataset_column: Int
    $url: String
    $style_color: String
    $style_text_color: String
    $style_colorful_background: Boolean
    $style_font_size: Int
    $style_length: Int
    $style_padding_horizontal: Int
    $style_padding_vertical: Int
    $style_position: [Float!]
    $style_show_timestamp: Boolean
    $style_show_arrow: Boolean
    $style_show_link: Boolean
  ) {
    update_annotation(
      story_id: $story_id
      annotation_id: $annotation_id
      date: $date
      title: $title
      summary: $summary
      target_chart_dataset_column: $target_chart_dataset_column
      url: $url
      style_color: $style_color
      style_colorful_background: $style_colorful_background
      style_font_size: $style_font_size
      style_text_color: $style_text_color
      style_length: $style_length
      style_padding_horizontal: $style_padding_horizontal
      style_padding_vertical: $style_padding_vertical
      style_position: $style_position
      style_show_timestamp: $style_show_timestamp
      style_show_arrow: $style_show_arrow
      style_show_link: $style_show_link
    ) {
      __typename

      ... on annotation {
        ...AnnotationFragment
      }

      ... on i_error {
        message
      }
    }
  }

  ${AnnotationFragment}
`;

export default UpdateAnnotationMutation;
